// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var ClientName = function (x) {
    return x;
};
var tsBridgeClientName = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ClientName")("__brandClientName"));
    }
};
var writeClientName = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showClientName = Data_Show.showString;
var readClientName = Simple_JSON.readString;
var ordClientName = Data_Ord.ordString;
var newtypeClientName = {
    Coercible0: function () {
        return undefined;
    }
};
var makeClientName = ClientName;
var eqClientName = Data_Eq.eqString;
export {
    ClientName,
    makeClientName,
    unwrap,
    newtypeClientName,
    eqClientName,
    ordClientName,
    showClientName,
    readClientName,
    writeClientName,
    tsBridgeClientName
};
//# sourceMappingURL=index.js.map
